import { useState } from 'react';
import { Button, Dialog, TextField, DialogActions, DialogTitle, DialogContent, CircularProgress, Box } from '@mui/material';
import { useMutation } from 'react-query';
import axiosClient from '../../lib/axios';
import { enqueueSnackbar } from 'notistack';

export default function DialogConfiguracaoEmail({
  open,
  recibo,
  onClose,
}: DialogConfiguracaoEmailProps) {
  const [email, setEmail] = useState('');

  const { mutate: compartilharReciboEmail, isLoading } = useMutation({
    mutationKey: "compartilhar-recibo-email",
    mutationFn: () =>
      axiosClient.post("/financeiro/contas-receber/compartilhar-recibo-email", {
        email,
        numero_recibo: recibo,
      }),
    onSuccess: () => {
      setEmail("");
      enqueueSnackbar("Email enviado com sucesso", {variant: 'success'})
      onClose();
    },
    onError: (error) => {
      console.error("Erro ao enviar o e-mail:", error);
    },
  });

  const handleEnviar = () => {
    if (!email || !validateEmail(email)) {
      enqueueSnackbar("Por favor, insira um e-mail válido!", {variant: 'warning'});
      return;
    }
    compartilharReciboEmail();
  };

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='xs'>
      <DialogTitle>Compartilhar recibo por E-mail</DialogTitle>
      <DialogContent>
        <Box py={2}>
          <TextField
            label="E-mail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            error={!!email && !validateEmail(email)}
            helperText={
              email && !validateEmail(email) ? "Por favor, insira um e-mail válido." : ""
            }
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancelar
        </Button>
        <Button
          onClick={handleEnviar}
          color="primary"
          variant="contained"
          disabled={isLoading || !email || !validateEmail(email)}
          startIcon={isLoading && <CircularProgress size={20} />}
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface DialogConfiguracaoEmailProps {
  open: boolean;
  recibo?: number;
  onClose: () => void;
}
